import a from "react";
import { getIconColor as m } from "./iconfont.es5470.js";
import h from "./iconfont.es5471.js";
const i = {
  display: "block"
}, x = ({ size: e = 16, useVw: n, useRem: c, color: l, withColor: o, removeClassName: t, disableSSR: d, style: r, ...p }) => {
  const g = r ? { ...i, ...r } : i;
  return /* @__PURE__ */ a.createElement(h, { disableSSR: d }, /* @__PURE__ */ a.createElement("svg", { "data-icon-id": "32px-heyuewangge", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 32 32", width: n ? ((e || 0) / 375 * 100).toFixed(5) + "vw" : e + (c ? "rem" : "px"), height: n ? ((e || 0) / 375 * 100).toFixed(5) + "vw" : e + (c ? "rem" : "px"), className: t ? "" : "iconpark-icon", style: g, fill: "none", ...p }, /* @__PURE__ */ a.createElement(
    "g",
    {
      className: t ? "" : "32px-åçº¦ç½æ ¼"
    },
    /* @__PURE__ */ a.createElement(
      "g",
      {
        className: t ? "" : "normal",
        fill: o ? m(l, 0, "#262933") : "#262933",
        datafollowfill: o ? m(l, 0, "#262933") : "#262933"
      },
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M8.5 4.1A3.9 3.9 0 0 0 4.6 8v14.999a3.9 3.9 0 0 0 3.9 3.9h3a.9.9 0 1 0 0-1.8h-3a2.1 2.1 0 0 1-2.1-2.1V8c0-1.16.94-2.1 2.1-2.1h13.18c1.16 0 2.1.94 2.1 2.1v7a.9.9 0 0 0 1.8 0V8a3.9 3.9 0 0 0-3.9-3.9H8.5Z"
        }
      ),
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M9.98 9.545a.9.9 0 1 0 0 1.8h9.427a.9.9 0 1 0 0-1.8H9.98Zm-.9 5.541a.9.9 0 0 1 .9-.9h3.18a.9.9 0 0 1 0 1.8H9.98a.9.9 0 0 1-.9-.9Zm12.827 5.731c.268.563.783.985 1.405 1.125L20.3 25.648a2.06 2.06 0 0 0-1.455-1.063l3.062-3.768Zm-7.019 1.697 1.858 2.99a2.056 2.056 0 0 1 1.534-.941l-1.862-2.999a.9.9 0 1 0-1.53.95Zm9.139-.539a2.059 2.059 0 0 0 1.506-.986l1.993 3.097a.9.9 0 0 1-1.513.974l-1.986-3.085Zm-1.519-2.041a1.256 1.256 0 1 0 2.511 0 1.256 1.256 0 0 0-2.51 0Zm-4.022 7.933a1.256 1.256 0 1 1 0-2.512 1.256 1.256 0 0 1 0 2.512Z"
        }
      )
    )
  )));
}, s = x;
export {
  s as default
};
